// Module
var code = "SHARE";
// Exports
module.exports = code;